import React from 'react'

import type { NextPage } from 'next'

import { integrityProgram } from 'data/seo'
import IntegrityProgram from 'views/integrity-program'

const IntegrityPage: NextPage = () => <IntegrityProgram />

export default IntegrityPage

export async function getStaticProps() {
  return {
    props: { SEO: integrityProgram }
  }
}
